import React from "react";
import SocCoverageIcons from "../Icons/SocCoverageIcons";

interface ISocCoverageCard{
  title: string;
  counterCurrent: number;
  counterMax: number;
  type?: string;
  lastGivenDate?: string;
}

const SocCoverageCard = ({
  title,
  counterCurrent,
  counterMax,
  lastGivenDate,
  type= "general",
}: ISocCoverageCard) => {
  const isComplete = counterCurrent === counterMax && lastGivenDate !== undefined;
  const isUnused = counterCurrent === 0 || !lastGivenDate;

  return (
    <div className={`flex-1 border-2 ${isComplete ?
      "bg-light-purple  border-dark-purple":
      "bg-white   border-dashed border-taupe-50"} 
      p-3 flex flex-col justify-between items-center rounded-lg gap-2`}>
      <SocCoverageIcons type={type} isComplete={isComplete} />
      <div className="text-center">
        <div className="text-sm font-semibold">{title}</div>
        <div className={`text-xs ${isUnused ? "text-gray-1" : "text-dark-purple"}`}>
          {isUnused ? "Not Used" : `Used ${lastGivenDate}`}
        </div>
        <div className="text-xs font-semibold text-gray-1 mt-0.5">
          {counterCurrent}/{counterMax}
        </div>
      </div>
    </div>
  );
};

export default SocCoverageCard;
